import axios from "axios";
import { environment } from "../environment/environment";
import gatewayService from "@/services/gateway-service";

const userService = {
    async getUserInfoV2(documentNumber) {
        let token = await axios.post(`${environment.isApiAuth}`);
        console.log(token);
        let result = await axios.get(`${environment.isApiClient}${documentNumber}?product=VIDACASH&channel=WEB&access_token=${token.data}`);

        return result;
    },



    async getUserInfo(documentNumber) {
       let token = await axios.get(
            `${environment.isTokenApiClientMasked}?product=VIDACASH&channel=WEB`,
        );
        let result = await axios.get(
            `${environment.isApiClientMasked}/${documentNumber}?product=VIDACASH&channel=WEB&access_token=${token.data}&visibility=masked`,

          );


        if(result.data.data.nombre){
            let dataEn = {
                "cumuloValido": result.data.data.cumuloValido,
                "clienteProducto": result.data.data.clienteProducto,
                "name": result.data.data.nombre,
                "lastName": result.data.data.apellidoPaterno,
                "secondLastName": result.data.data.apellidoMaterno,
                "dob": result.data.data.fechaNacimiento,
                "gender": result.data.data.sexo,
                "email": result.data.data.email,
                "identificationType": result.data.data.idTipoDocumento,
                "identificationNumber": result.data.data.numeroDocumento,
                "phone": result.data.data.numeroTelefono,
                "passPlaft": result.data.data.passPlaft,
                "montoParaAdquirirPoliza": result.data.data.montoParaAdquirirPoliza,
                "applyAmountMax": result.data.data.applyAmountMax,
                "fullName" : result.data.data.nombre +' '+result.data.data.apellidoPaterno+' '+result.data.data.apellidoMaterno
            }
            let dataR = {
                "cumuloValido": result.data.data.cumuloValido,
                "clienteProducto": result.data.data.clienteProducto,
                "nombre": result.data.data.nombre,
                "apellidoPaterno": result.data.data.apellidoPaterno,
                "apellidoMaterno": result.data.data.apellidoMaterno,
                "fechaNacimiento": result.data.data.fechaNacimiento,
                "sexo": result.data.data.sexo,
                "email": result.data.data.email,
                "idTipoDocumento": result.data.data.idTipoDocumento,
                "numeroDocumento": result.data.data.numeroDocumento,
                "numeroTelefono": result.data.data.numeroTelefono,
                "passPlaft": result.data.data.passPlaft,
                "montoParaAdquirirPoliza": result.data.data.montoParaAdquirirPoliza,
                "applyAmountMax": result.data.data.applyAmountMax,
                "nombreCompleto" : result.data.data.nombre +' '+result.data.data.apellidoPaterno+' '+result.data.data.apellidoMaterno
            }
            window.localStorage.setItem('__maskedClient__', JSON.stringify(dataR));
            window.localStorage.setItem('__maskedClientEn__', JSON.stringify(dataEn));
            window.localStorage.setItem('__isClient__', JSON.stringify(true));
        }else{
            let oldClient = {
                "email":"",
                "name":"",
                "lastName":"",
                "secondLastName":"",
                "dob":"",
                "inputDob":"",
                "gender":"",
                "phone":"",
                "identificationNumber":documentNumber,
                "identificationType":"dni",
                "inputDobBraze":"",
                "fullName":""
            }
            window.localStorage.setItem('__isClient__', JSON.stringify(false));
            window.localStorage.setItem('__maskedClient__', JSON.stringify(oldClient));
        }

        return result;
    },

    async getUserLead(documentNumber) {
        let result = await axios.get(`${environment.apiLeads}${documentNumber}`);
        return result;
    },


    saveClient(newClientData){
        let oldClientData = JSON.stringify(window.localStorage.getItem("__maskedClient__"))

        try{
            const requestBody = {
                api_id: environment.apiGatewaySaveClient,
                body: {
                    "numeroDocumento": newClientData.identificationNumber,
                    "nombre": newClientData.firstName,
                    "apellidoPaterno": newClientData.lastName,
                    "apellidoMaterno": newClientData.secondLastName,
                    "fechaNacimiento": newClientData.dateOfBirth,
                    "sexo": newClientData.gender,
                    "numeroTelefono": newClientData.phone,
                    "telefono": newClientData.phone,
                    "email": newClientData.email,
                    "dni": newClientData.identificationNumber,
                    "channel": "WEB"
                },
                replace: gatewayService.getChangesCustomerData("", newClientData, oldClientData),
                product: "VIDACASH"
            };
            return gatewayService.postApiGateway(requestBody)
        } catch (error) {
            console.error('Error', error);
        }
    },


}

export default userService;